// extracted by mini-css-extract-plugin
module.exports = {"title":"Page_title__DHzuq","callout":"Page_callout__ma_3J","container":"Page_container__mUemw","hidden":"Page_hidden__3YtA0","header":"Page_header__HBVG0","nav":"Page_nav__205y7"};